import { render, staticRenderFns } from "./FilesNavigationSearch.vue?vue&type=template&id=66253ca2"
import script from "./FilesNavigationSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesNavigationSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports